import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Countdown.css';
import url from 'url';
import { FetchResultVisible } from '../actions/EpikBoxes';

const Countdown = () => {
  const dispatch = useDispatch();
  const initiateAlarmTimer = useSelector(state => state.UIState.epikBoxes.initiateAlarmTimer);

  const urlObj = url.parse(document.location.href, true);
  const innerBox = urlObj.path.includes('company');

  const [time, setTime] = useState({ h: 0, m: 0, s: 0 });
  const [timeLeft, setTimeLeft] = useState(initiateAlarmTimer || 0);
  const [start, setStart] = useState(false);
  const intervalRef = useRef();

  const fetchResult = async status => {
    await dispatch(FetchResultVisible(status));
  };

  useEffect(() => {
    clearInterval(intervalRef.current);
    if (initiateAlarmTimer > 0) {
      setStart(true);
      setTimeLeft(initiateAlarmTimer);
      fetchResult(true);
    } else {
      setTimeLeft(initiateAlarmTimer);
      clearInterval(intervalRef.current);
      fetchResult(false);
    }
  }, [initiateAlarmTimer]);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setTimeLeft(t => t - 1);
    }, 1000);
    setStart(true);
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (!innerBox) {
      setTimeLeft(0);
    }
    if (timeLeft <= 0) {
      clearInterval(intervalRef.current);
      fetchResult(false);
    }
    if (start) {
      intervalRef.current = setInterval(() => {
        setTimeLeft(t => t - 1);
      }, 1000);
      setStart(false);
    }
    // convert timeLedt into minutes, seconds
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft - minutes * 60;
    setTime({ h: 0, m: minutes, s: seconds });
  }, [timeLeft]);

  return (
    <div className="text-center pl-1">
      {innerBox && timeLeft > 0 && (
        <p className="time-text">
          Alarm Test Mode Initiated:
          {` ${time.m} Min ${time.s} Sec`}
        </p>
      )}
    </div>
  );
};

export default Countdown;
